import { Controller } from "@hotwired/stimulus"
import confetti from "canvas-confetti"

export default class extends Controller {
    connect() {
        // Create a canvas element inside the host element
        const canvas = this.buildCanvas()
        const body = document.querySelector('.form-response-body')
        body.appendChild(canvas)
        canvas.width = body.clientWidth
        canvas.height = body.clientHeight
        canvas.confetti = confetti.create(canvas, { resize: true })

        const seconds = 3
        const end = Date.now() + (seconds * 1000);

        const frame = () => {
            canvas.confetti({
                particleCount: 2,
                angle: 60,
                spread: 55,
                origin: { x: 0 },
                colors: ['#c4262d', '#ffffff']
            })
            canvas.confetti({
                particleCount: 2,
                angle: 120,
                spread: 55,
                origin: { x: 1 },
                colors: ['#c4262d', '#ffffff']
            })

            if (Date.now() < end) {
                requestAnimationFrame(frame)
            }
        }
        frame()
    }

    buildCanvas() {
        const canvas = document.createElement('canvas')
        canvas.style.position = 'absolute'
        canvas.style.top = '0'
        canvas.style.left = '0'
        canvas.style.pointerEvents = 'none' // Make sure the canvas doesn't block clicks
        return canvas
    }
}
